import { forwardRef, type ComponentProps, type ElementType } from 'react';
import { cn } from '@/app/_lib/utils';

export interface BentoCardProps extends ComponentProps<'div'> {
  /**
   * Render as a different HTML element
   * @default 'div'
   */
  as?: ElementType;
}

export const BentoCard = forwardRef<HTMLDivElement, BentoCardProps>(
  ({ as: Component = 'div', className, children, ...props }, ref) => {
    return (
      <Component
        ref={ref}
        data-slot="card"
        className={cn(
          'flex flex-col overflow-hidden rounded-bento-card border-bento-card bg-card text-card-foreground shadow-bento-card xl:shadow-bento-card-desktop',
          className
        )}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

BentoCard.displayName = 'BentoCard';

export default BentoCard;
